import * as React from "react";
const SvgArrowDoubleLeft20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M10.707 4.707 9.293 3.293 2.586 10l6.707 6.707 1.414-1.414L5.414 10l5.293-5.293Zm6 0-1.414-1.414L8.586 10l6.707 6.707 1.414-1.414L11.414 10l5.293-5.293Z",
      clipRule: "evenodd"
    })
  );
export default SvgArrowDoubleLeft20Px;
